/**
 * @generated SignedSource<<671a310303b9830741b5b26db9e25bc5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type PaymentProcessor = "BRAINTREE" | "KLARNA" | "OFF_PLATFORM" | "STRIPE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type checkoutTransactionReducer_buyer$data = {
  readonly addressBook: {
    readonly addressList: ReadonlyArray<{
      readonly serviceId: string | null;
      readonly validation: {
        readonly buyerShipping: {
          readonly valid: boolean | null;
        } | null;
      } | null;
    } | null> | null;
    readonly personalAddress: {
      readonly serviceId: string | null;
    } | null;
  } | null;
  readonly firstValidShippingAddress: {
    readonly serviceId: string | null;
  } | null;
  readonly preferences: {
    readonly currency: Currency | null;
  } | null;
  readonly serviceId: string | null;
  readonly wallet: {
    readonly paymentMethods: ReadonlyArray<{
      readonly paymentMethod: {
        readonly __typename: string;
        readonly apiType: string | null;
        readonly isExpired?: boolean | null;
        readonly paymentProcessor?: PaymentProcessor | null;
        readonly token?: string | null;
      } | null;
      readonly shippingAddresses: ReadonlyArray<{
        readonly serviceId: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "checkoutTransactionReducer_buyer";
};
export type checkoutTransactionReducer_buyer$key = {
  readonly " $data"?: checkoutTransactionReducer_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutTransactionReducer_buyer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutTransactionReducer_buyer"
};

(node as any).hash = "fe966516c9b86822fe8f128e990fe9ab";

export default node;
